module.exports = __webpack_public_path__ + "img/details.a358c021.svg";